module.exports = __webpack_public_path__ + "static/media/trunk.a3f805ab.svg";